export enum ClassCategoryEnum {    
    'Business' = 1,
    'First' = 2,
    'Economy' = 3,
    'Restaurant' = 4,
    'Sleeper' = 5,
    'Couchette' = 6, // Liegewagen
    'UrbanTransport' = 7 // Stadtverkehr
}


